import Axios from "axios";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";
import BaseService from "./base.service";
import { baseURL } from "./axios.utils";

class TeamSettingsService extends BaseService {
  getList = () => this.axios.get(API_ENDPOINTS.TEAM_SETTINGS_LIST);
  upsert = (data) => this.axios.put(API_ENDPOINTS.TEAM_SETTINGS_UPSERT, data);
  toggleSync = (id, data) => this.axios.patch(API_ENDPOINTS.TEAM_SETTINGS_TOGGLE.replace("{teamWorkSheetSettingId}", id), data);
  bulkSync = (id, data) => this.axios.post(API_ENDPOINTS.TEAM_SETTINGS_BULK_SYNC.replace("{teamWorkSheetSettingId}", id), data);
  clearSettings = (id) => this.axios.patch(API_ENDPOINTS.TEAM_SETTINGS_CLEAR.replace("{teamWorkSheetSettingId}", id));
  deleteSettings = (id) => this.axios.delete(API_ENDPOINTS.TEAM_SETTINGS_DELETE.replace("{teamWorkSheetSettingId}", id));
  getSyncErrors = (id) =>
    this.axios.get(API_ENDPOINTS.TEAM_SETTINGS_SYNC_ERRORS.replace("{teamWorkSheetSettingId}", id));
  exportSyncErrorsCsv = (id) =>
    Axios({
      url: `${baseURL}${API_ENDPOINTS.TEAM_SETTINGS_SYNC_ERRORS_EXPORT.replace("{teamWorkSheetSettingId}", id)}`,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
}

export default new TeamSettingsService();
